<div class="heading">{{heading}}</div>
<div *ngFor="let item of configService.items | isUserSelectable | itemCategory:category | itemLanguage:configService.language" class="element">
  <div style.background-image="url('{{item.imageUrl}}')" class="image"></div>
  <div class="title">{{item.information.title}}</div>
  <p class="preformatted-text">{{item.information.description}}</p>
</div>
<div class="element pseudo-element"></div>
<div class="element pseudo-element"></div>
